<app-leveltwo [pageName]="'General Info'">
<div class="General">
  <h3>{{'Refinance.SearchTitle'|translate}}</h3>
  <h4>{{'Refinance.Will'|translate}}</h4>
  <p>{{'Refinance.Willrefinancing'|translate}}</p>
  <p>{{'Refinance.Refinancingarrangements'|translate}}</p>
  <h5>{{'Refinance.AddingaCosigner'|translate}}</h5>
  <strong>{{'Refinance.Example'|translate}}</strong><br>
  <p>{{'Refinance.Jackowns'|translate}}</p>
  <p>{{'Refinance.However'|translate}}</p>

  <h5>{{'Refinance.Removinganowner'|translate}}</h5>
  <strong>{{'Refinance.Example'|translate}}</strong><br>
  <p>{{'Refinance.JackandJill'|translate}}</p>
  <p>{{'Refinance.HoweverJill'|translate}}</p>

  <h5>{{'Refinance.AcquiringTitle'|translate}}</h5>
  <strong>{{'Refinance.Example'|translate}}</strong><br>
  <p>{{'Refinance.Jackplans'|translate}}</p>
  <p>{{'Refinance.LaterJack'|translate}}</p>

  <h5>{{'Refinance.RemovingPropertyfromtrust'|translate}}</h5>
  <strong>{{'Refinance.Example'|translate}}</strong><br>
  <p>{{'Refinance.JackandJoan'|translate}}</p>

  <h5>{{'Refinance.RemovingPropertyfromlegal'|translate}}</h5>
  <strong>{{'Refinance.Example'|translate}} 1</strong><br>
  <p>{{'Refinance.Apieceof1'|translate}}</p>

  <strong>{{'Refinance.Example'|translate}} 2</strong><br>
  <p>{{'Refinance.Apieceof2'|translate}}</p>
  <p>{{'Refinance.Jacklater'|translate}}</p>



</div>
</app-leveltwo>

